export const handleOptionsNavigation = _ref => {
  let {
    e,
    setDropdownState,
    wrapperRef,
    buttonRef,
    isOpen
  } = _ref;
  var _a, _b;
  if (!isOpen || !['ArrowDown', 'ArrowUp', 'Escape', 'Tab'].includes(e.key)) {
    return;
  }
  const elements = (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.ds-multiselect-option:not([disabled])');
  if (e.key === 'ArrowDown') {
    e.preventDefault();
    setDropdownState("open" /* DropdownStates.OPEN */);
    const firstOption = elements[0];
    firstOption === null || firstOption === void 0 ? void 0 : firstOption.focus();
  }
  if (e.key === 'ArrowUp') {
    e.preventDefault();
    setDropdownState("open" /* DropdownStates.OPEN */);
    const lastOption = elements[elements.length - 1];
    lastOption === null || lastOption === void 0 ? void 0 : lastOption.focus();
  }
  if (e.key === 'Escape') {
    (_b = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _b === void 0 ? void 0 : _b.focus();
    return setDropdownState("closed" /* DropdownStates.CLOSED */);
  }
  if (e.key === 'Tab' && !e.shiftKey) {
    return setDropdownState("closed" /* DropdownStates.CLOSED */);
  }
};